/*
 * File: Message.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:23 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import {
	Card,
	IconButton
} from '../../../components';

// Constants
import { DetailPanelWidth, mobileBreakpoint, tabBarBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	gap: 24px;
	padding: 40px 0px 60px;
	width: 100%;
	justify-content: center;
	align-items: start;

	.detailPanel {
		display: none !important;

		@media only screen and (min-width: ${tabBarBreakpoint}em) {
			display: block !important;
		}
	}
`;

export const MessageCard = styled(Card)`
	padding: 24px 36px 14px;
	max-width: ${DetailPanelWidth}px;
	width: 100%;
	position: relative;
`;

export const CardHeader = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 0px 0px 12px;
`;

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const BackButton = styled(IconButton)`
	background-color: ${({ theme }) => theme.neutralButton};
	border-radius: 50%;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PromptContainer = styled.div`
	flex-grow: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 20px 0px 10px;

	h5 {
		text-transform: uppercase;
		font-size: 0.7rem;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const ActionBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin: 20px 0px 0px;
	align-items: center;

	.love {
		font-size: 1.0rem;
	}
	.comment {
		font-size: 1.0rem;
	}
	.active {
		color: ${({ theme }) => theme.brandHighlight};
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;

	span {
		cursor: pointer;
	}

	.rightIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-right: 4px;
		}
		& > span {
			margin: 0px;
		}
	}
	.leftIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-left: 6px;
		}
		& > span {
			margin: 0px;
		}
	}
`;

export const TriggerWarning = styled.div`
	background-color: ${({ theme }) => theme.statusWarningLighter};
	border: 1px solid ${({ theme }) => theme.statusWarningBase};
	padding: 5px 9px 5px 9px;
    border-radius: 8px;
	margin: 12px 0px 8px;

	p {
		color: ${({ theme }) => theme.statusWarningBase};
	}
`;

export const ActionSpacer = styled.div`
	flex-grow: 1;
`;

export const CommentsContainer = styled.div`
	position: relative;
	margin: 30px 0px 20px;
`;

export const CommentSignpost = styled.div`
	position: relative;
`;

export const CommentsDisabledLabel = styled.div`
	p {
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const NavigationBar = styled.div`
	display: grid;
	grid-gap: 10px;
	grid-template-columns: repeat(1, 1fr);
	padding: 30px 0px 0px;

	& > div {
		width: 100%;
	}
	button {
		width: 100%;

		span {
			font-size: 0.85rem;
		}
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		grid-template-columns: repeat(3, 1fr);
	}
`;
